import assetUtils, { Asset } from 'app-lib/assetUtils'
import providerUtils from 'app-lib/providerUtils'
import { BigNumber } from '@0x/utils'
import { FulcrumProvider } from '../../../fulcrum/src/services/FulcrumProvider'

export default class LendService {
  fulcrumProvider: FulcrumProvider

  getDependenciesStrict(asset: Asset) {
    const deps = providerUtils.getDependenciesStrict(this.fulcrumProvider)
    const iTokenContract = deps.contractsSource.getITokenContract(asset)
    return { ...deps, iTokenContract }
  }

  /**
   * @param asset the asset the user wants to lend
   * @param amount not in wei
   */
  lend(asset: Asset, amount: BigNumber) {
    const { iTokenContract, userAddress, chainId } = this.getDependenciesStrict(asset)
    const isNative = assetUtils.isNativeTokenForNetwork(chainId, asset)
    const amountInBaseUnits = providerUtils.inBaseUnits(chainId, asset, amount)

    if (isNative) {
      const tx = iTokenContract.mintWithEther(userAddress)
      return providerUtils.runTx(this.fulcrumProvider, tx, iTokenContract, amountInBaseUnits)
    } else {
      const tx = iTokenContract.mint(userAddress, amountInBaseUnits)
      return providerUtils.runTx(this.fulcrumProvider, tx, iTokenContract)
    }
  }

  /**
   * @param asset the asset the user wants to lend
   * @param amount not in wei
   */
  unlend(asset: Asset, amount: BigNumber) {
    const { iTokenContract, userAddress, chainId } = this.getDependenciesStrict(asset)
    const isNative = assetUtils.isNativeTokenForNetwork(chainId, asset)
    const amountInBaseUnits = providerUtils.inBaseUnits(chainId, asset, amount)

    const tx = isNative
      ? iTokenContract.burnToEther(userAddress, amountInBaseUnits)
      : iTokenContract.burn(userAddress, amountInBaseUnits)

    return providerUtils.runTx(this.fulcrumProvider, tx, iTokenContract)
  }

  constructor(provider: FulcrumProvider) {
    this.fulcrumProvider = provider
  }
}
